import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "../../auth/AuthContext";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import UtilMethods from "../../util/UtilMethods";
import { sendEmail } from "../../services/EmailSender";
import { useLocation, useNavigate } from "react-router-dom";
import AlertModal from "../common/AlertModal"; // Import the reusable AlertModal component
import Address from "../common/Address";
import ConsentModal from "../common/ConsentModal";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

import {
  isZoomTokenValid,
  getZoomAccessToken,
  assignMeetingId,
} from "../../services/ZoomService"; // Named import
import {
  updateApprovalDetails,
  fetchSabbathDetails,
  updateSabbathDetails,
  registerSabbath,
} from "../../services/AdminServices";
import {
  faChild,
  faEnvelope,
  faPhone,
  faHeadset,
  faUser,
  faUsers,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import { COUNTRY_BY_LANGUAGE } from "../common/Constants";
const SabbathRegistrationPage = () => {
  const browserCountry = navigator.language.split("-")[1]; // "US", "MX", "FR"
  const [showConfirmModal, setShowConfirmModal] = useState(false); // state to control modal visibility
  const [showSuccessModal, setShowSuccessModal] = useState(false); // state to control modal visibility
  const [showConsentModal, setShowConsentModal] = useState(false); // Modal visibility state
  const [successMessage, setSuccessMessage] = useState("");
  const [modalType, setModalType] = useState("sabbath"); // Default type
  const [showCancelModal, setShowCancelModal] = useState(false); // state to control modal visibility
  const location = useLocation();
  const navigate = useNavigate();

  const record = location.state?.record || {};
  const {
    user,
    accessToken,
    setZoomToken,
    expiryTime,
    refreshToken,
    userType,
  } = useAuth();

  const [isApproving, setIsApproving] = useState(false);
  const [approvalMessage, setApprovalMessage] = useState("");
  const isGuest = userType === "G";
  const isAdmin = userType?.includes("A") || userType?.includes("S"); // Check if the user is an admin or super admin
  const [phoneCountry, setPhoneCountry] = useState( browserCountry || "US");
  const getFieldValue = (field, defaultValue = "") => {
    if (record?.[field]) {
      return record[field];
    } else if (!(isAdmin || isGuest) && user?.[field]) {
      return user[field];
    } else {
      return defaultValue;
    }
  };

  const [formData, setFormData] = useState({
    id: record?.id || "",
    zoomID: record?.zoomID || "",
    zoomInvite:
      typeof record?.zoomInvite === "boolean" ? record.zoomInvite : false,
    joinUrl: record?.joinUrl || "",
    firstName: getFieldValue("firstName"),
    lastName: getFieldValue("lastName"),
    email: getFieldValue("email"),
    phone: getFieldValue("phone"),
    address: getFieldValue("address", ""),
    city: getFieldValue("city", ""),
    state: getFieldValue("state", ""),
    zip: getFieldValue("zip", ""),
    country: getFieldValue("country", ""),
    sabbathGroup: record?.sabbathGroup || "US",
    status: record?.status || "New",
    category: record?.category || "Adult",
    type: record?.type || "GA",
    errors: {},
    submittedData: null,
    isSubmitting: false,
    consentToUseData:
      typeof record?.consentToUseData === "boolean"
        ? record.consentToUseData
        : false,
    remarks: record?.remarks || "", // Add remarks field
  });

  const alertTimeoutRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      UtilMethods.log("info", " user data...", user);
      UtilMethods.log("info", " record data...", record);
      if (user && !record?.id) {
        try {
          const data = await fetchSabbathDetails({
            exactEmail: record?.email ? record?.email : user.email,
          });
          //UtilMethods.log("info", "fetchSabbathDetails data...", data);
          console.log("fetchSabbathDetails data...", data);
          if (Array.isArray(data) && data.length > 0) {
            if (data[0]?.id) {
              setFormData((prevState) => ({
                ...prevState,
                ...data[0],
              }));
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    };
    setPhoneCountry( browserCountry || "US");
    console.log("PrayerRequestForm useEffect language:", phoneCountry);


    fetchData();
  }, [user]);

  const cancelSubmit = () => {
    setShowConfirmModal(false); // Close the modal without submitting
  };
  // Handle field changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  // Function to handle the link click and show the modal
  const handleShowConsentModal = () => {
    setModalType("sabbath"); // Set the appropriate type
    setShowConsentModal(true); // Show the modal
  };
  const redirectToZoom = () => {
    const clientId = process.env.REACT_APP_ZOOM_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_ZOOM_REDIRECT_URI; // Append /callback to the redirect URI
    const zoomBaseUrl = "https://zoom.us/oauth/authorize"; // Define as constant
    if (!accessToken) {
      if (!clientId || !redirectUri) {
        console.error(
          "ZOOM_CLIENT_ID or ZOOM_REDIRECT_URI is not defined in environment variables."
        );
        alert("Zoom integration is not configured. Please contact support.");
        return;
      }

      // Construct the Zoom OAuth URL
      const zoomAuthUrl = `${zoomBaseUrl}?response_type=code&client_id=${encodeURIComponent(
        clientId
      )}&redirect_uri=${encodeURIComponent(redirectUri)}`;

      console.log("Redirecting to Zoom Authorization URL:", zoomAuthUrl);
      window.location.href = zoomAuthUrl; // Redirect the user to Zoom for authorization
    } else {
      console.log("Zoom Token available:");
    }
  };
  // Function to close the modal
  const handleCloseConsentModal = () => {
    setShowConsentModal(false); // Hide the modal
  };
  // Function to close the modal
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false); // Hide the modal
    setIsApproving(false); // Reset loading state
    setSuccessMessage(""); // Clear success message
    setFormData((prevState) => ({
      ...prevState,
      isSubmitting: false,
    }));
    if (record.id) {
      navigate("/listSabbathReq", { state: { record: {} } });
    } else {
      navigate("/", { state: { record: {} } });
    }
    resetForm();
  };
  // Handle Sabbath Group change
  const handleSabbathGroupChange = (e) => {
    setFormData({
      ...formData,
      sabbathGroup: e.target.value,
    });
  };

  // Handle radio button change for category selection
  const handleCategoryRadioChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      category: e.target.value,
      type: e.target.value === "Adult" ? "GA" : "YGA", // Set default sabbathGroup based on category
    }));
  };

  // Handle radio button change for category selection
  const handleCheckChange = (e) => {
    setFormData({
      ...formData,
      consentToUseData: e.target.checked,
    });
  };

  // Phone change handler
  const handlePhoneChange = (phone) => {
    setFormData((prevState) => ({
      ...prevState,
      phone: phone,
    }));
  };

  // Form validation
  const validateForm = () => {
    // console.log("validateForm formData ", formData);
    const {
      id,
      zoomID,
      zoomInvite,
      joinUrl,
      firstName,
      lastName,
      email,
      phone,
      address,
      city,
      category,
      state,
      zip,
      country,
      sabbathGroup,
      consentToUseData,
    } = formData;
    const errors = {};
    //console.log("validateForm country ", country);

    if (!firstName) errors.firstName = "First Name is required";
    if (!lastName) errors.lastName = "Last Name is required";
    if (!email || !UtilMethods.validateEmail(email))
      errors.email = "Valid email is required";
    if (!phone) errors.phone = "Valid phone number is required";
    if (!UtilMethods.validatePhone(phone))
      errors.phone = "Valid phone number is required. Confirm country code.";
    // if (!address) errors.address = "Address line 1 is required";
    // if (!city) errors.city = "City is required";
    if (!state) errors.state = "State is required";
    // if (!zip) errors.zip = "ZIP code is required";
    if (!country) errors.country = "Country is required";
    if (!sabbathGroup) errors.sabbathGroup = "Sabbath group is required";

    if (!consentToUseData) errors.consentToUseData = "Consent is required";
    setFormData((prevState) => ({
      ...prevState,
      errors,
    }));
    console.log("validateForm errors ", errors);
    return errors;
  };
  // Handle 'Approve' button click
  const handleApproveClick = async () => {
    if (
      !userType ||
      typeof userType !== "string" ||
      (!userType.includes("A") && !userType.includes("S"))
    )
      return; // Only allow if user is admin (userType = "A" or "S")

    const approvedBy = user?.userID;
    console.log(" approvedBy", approvedBy);
    setIsApproving(true); // Set loading state while making the API call
    try {
      // Trigger the API call for approval (replace with your actual API endpoint)
      console.log("handleApproveClick record.id", record.id);
      if (record.id) {
        if (!accessToken) {
          redirectToZoom();
          return;
        } else if (!isZoomTokenValid(expiryTime) && refreshToken) {
          const tokenData = await getZoomAccessToken(
            null,
            refreshToken,
            setZoomToken
          );
          // console.log("Token data:", tokenData);

          if (tokenData && tokenData.access_token && tokenData.expires_in) {
            console.log("Setting Zoom token with expiry...");

            // If the response includes a refresh token, pass it as well
            const { access_token, refresh_token, expires_in } = tokenData;

            // Pass the token, refresh token, and expiry to the context
            setZoomToken(access_token, refresh_token, expires_in);
          } else {
            console.error("Failed to obtain Zoom token.");
            alert("Failed to authorize with Zoom.");
            redirectToZoom();
            return;
          }
        }
        console.log("Before Server call . record: ", record);
        console.log("Before Server call . accessToken: ", accessToken);
        console.log("Before Server call . approvedBy: ", approvedBy);
        if (!record) throw new Error("Record not found");
        const meetingId = assignMeetingId(record.category, record.sabbathGroup);
        if (!meetingId) throw new Error("Zoom Meeting not found");
        const response = await updateApprovalDetails({
          status: "Approved",
          approvedBy: approvedBy,
          accessToken: accessToken,
          meetingId: meetingId,
          type: record.type,
        });
        console.log("After Server call . response: ", response);
      }
    } catch (error) {
      console.error("Error approving user:", error);
      setApprovalMessage("Error in approving user.");
    } finally {
      setIsApproving(false); // Reset loading state after the API call is finished
    }
  };

  // Show modal and set formData before submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length === 0) {
      setFormData((prevState) => ({
        ...prevState,
        isSubmitting: true,
      }));
      setShowConfirmModal(true); // Show the modal
    } else {
      showAlert(
        "Please fill in all required fields: " + Object.values(errors)[0],
        "danger"
      );
    }
  };
  // Handle form submission after modal confirmation
  const confirmSubmit = async () => {
    const { address, city, state, zip, country } = formData;
    const fullAddress = `${address}, ${city}, ${state}, ${zip}, ${country}`;
    try {
      // API request to submit the form
      console.log(" /n Sabbath/register formData", formData);
      console.log(" %%%%% sabbath/register record.id", record.id);
      console.log(" ^^^^^ sabbath/register id", id);
      let response;
      setShowConfirmModal(false); // Close the modal after submitting
      if (record.id) {
        // Update existing record
        console.log(" ^^^^^ sabbath/register updateID", record.id);

        response = await updateSabbathDetails(formData);

        navigate("/listSabbathReq");
      } else {
        // update new record
        if (id) {
          console.log(" ^^^^^ sabbath/register updateID", id);
          response = await updateSabbathDetails(formData);
        } else {
          response = await registerSabbath(formData);
        }
        // On success, set saved data and clear error
        console.log(" sabbath/register response ", response);
        if (response.data && response.data.savedData) {
          setFormData({
            id: response.data.savedData.id,
            zoomID: response.data.savedData.zoomID,
            zoomInvite: response.data.savedData.zoomInvite,
            joinUrl: response.data.savedData.joinUrl,
            firstName:
              response.data.savedData.firstName || user?.firstName || "",
            lastName: response.data.savedData.lastName || user?.lastName || "",
            email: response.data.savedData.email || user?.email || "",
            phone: response.data.savedData.phone || user?.phone || "",
            address: response.data.savedData.address || user?.address || "",
            city: response.data.savedData.city || user?.city || "",
            state: response.data.savedData.state || user?.state || "",
            zip: response.data.savedData.zip || user?.zip || "",
            country: response.data.savedData.country || user?.country || "",
            sabbathGroup: response.data.savedData.sabbathGroup || "US",
            consentToUseData: response.data.savedData.consentToUseData,
            status: response.data.savedData.status || "Pending",
            category: response.data.savedData.category || "Adult",
            type: response.data.savedData.type || "GA",
            errors: {},
            submittedData: null,
            isSubmitting: false,
          }); // the response includes the saved data
        }
        //setFormData(response.data.savedData);
        const emailResponse = await sendEmail(
          formData,
          "SABBATH_REQUEST",
          "service_sabbath"
        );
        // On success, set saved data and clear error
        console.log("##### sabbath/emailResponse response ", emailResponse);
        console.log(
          " emailResponse.error?.status #",
          emailResponse.error?.status
        );
        console.log(" emailResponse.error?.text #", emailResponse.error?.text);
        if (emailResponse.success) {
          setSuccessMessage(
            "Sabbath Registration Received,Please reply to the Email to complete the Registration"
          );
          setShowSuccessModal(true); // Show the success modal
          showAlert(
            "Sabbath Registration Received,Please reply to the Email to complete the Registration",
            "success"
          );
        } else {
          if (emailResponse.error?.status === 422) {
            showAlert(
              `Failed to send email: ${emailResponse.error?.text || ""}`,
              "danger"
            );
          } else {
            showAlert("Failed to send email", "danger");
          }
        }
      }

      //setFormData(response.data.savedData);
      setError("");
    } catch (error) {
      console.log(" sabbath/register response ", error);
      // Check if there is a response from the backend with specific error details
      if (error?.code === 409) {
        console.log(
          "409 error sabbath/register response error ",
          error?.details?.message
        );
        showAlert(
          `Error: ${error?.details?.message} . Please contact @ sabbath@graceanointing.org`,
          "danger"
        );
      } else if (error?.response?.data?.details) {
        // Display detailed error from the backend if available
        showAlert(
          `Error: ${error?.response?.data?.details} . Please contact @ sabbath@graceanointing.org`,
          "danger"
        );
      } else if (error?.response?.data?.error) {
        // Fallback to a generic error message if no specific details are provided
        showAlert(
          `Error: ${error?.response?.data?.error} . Please contact @ sabbath@graceanointing.org`,
          "danger"
        );
      } else {
        // General fallback message if backend doesn't provide a structured response
        showAlert(
          "Error submitting form. Please try again. Or Please contact @ sabbath@graceanointing.org",
          "danger"
        );
      }
      setFormData((prevState) => ({
        ...prevState,
        isSubmitting: false,
      }));
    }
  };

  // Alert management
  const [alert, setAlert] = useState({
    message: "",
    type: "",
  });

  const showAlert = (message, type) => {
    setAlert({ message, type });

    if (alertTimeoutRef.current) clearTimeout(alertTimeoutRef.current);

    alertTimeoutRef.current = setTimeout(() => {
      setAlert({ message: "", type: "" });
    }, 5000);
  };

  useEffect(() => {
    return () => {
      if (alertTimeoutRef.current) clearTimeout(alertTimeoutRef.current);
    };
  }, []);

  // Reset form fields and errors
  const resetForm = () => {
    setFormData({
      record: {},
      id: null,
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      email: user?.email || "",
      phone: user?.phone || "",
      address: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      category: "Adult",
      sabbathGroup: "", // Reset sabbathGroup field
      consentToUseData: false,
      errors: {},
      submittedData: null,
      isSubmitting: false,
    });
  };

  const confirmCancel = () => {
    if (record.id) {
      navigate("/listSabbathReq", { state: { record: {} } });
    } else {
      navigate("/", { state: { record: {} } });
    }
    resetForm();
    setShowCancelModal(false);
  };
  const handleCancel = () => {
    setShowCancelModal(true);
  };
  const cancelCancel = () => {
    setShowCancelModal(false);
  };
  const {
    id,
    zoomID,
    zoomInvite,
    joinUrl,
    firstName,
    lastName,
    email,
    phone,
    address,
    city,
    state,
    zip,
    country,
    category,
    type,
    sabbathGroup,
    consentToUseData,
    errors,
    isSubmitting,
  } = formData;

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">Sabbath Registration</h1>
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <h3 className="text-center mb-4">
          Walk Through the Way of Grace Anointing
        </h3>

        <h4 className="text-center">
          <i>
            "If you refrain from trampling the Sabbath, from following your own
            pursuits on my holy day; If you call the Sabbath a delight, the
            LORD’s holy day glorious; If you glorify it by not following your
            ways, seeking your own interests, or pursuing your own affairs..."
          </i>{" "}
          - Isaiah 58:13-14
        </h4>
        {!["A", "S"].some((type) => userType?.includes(type)) && (
          <>
            <p className="text-center">
              The Sabbath Prayer is a heartfelt gathering where we come together
              for prayer, praise, and worship, creating a space to share and
              reflect on God's Word. We invite you to join us as we support and
              uplift one another in our spiritual journeys. The Word of God will
              be given from Anakkara Marian Retreat Center. The Sabbath Prayer
              sessions will be held on Sunday evenings for US Region. For
              adults, the sessions will take place from{" "}
              <b>5:00 PM to 7:00 PM CST</b> in <u>Malayalam</u>, and for youth,
              from <b>5:30 PM to 6:30 PM CST</b> in <u>English</u>. These
              sessions will be conducted via Zoom. If you have any questions or
              clarifications, please reach out to{" "}
              <a href="mailto:sabbath@graceanointing.org">
                sabbath@graceanointing.org
              </a>
              .
            </p>
          </>
        )}
        {/* If there is saved data, show it */}
        {formData.id && (
          <div>
            <p className="alert alert-success">
              <strong>Registration ID:</strong> {formData.id}
              <strong> | Zoom Invite:</strong>{" "}
              {formData.zoomInvite ? "Yes" : "No"}
              <strong> | Zoom ID:</strong> {formData.zoomID}
              {formData.joinUrl && (
                <>
                  <strong> | URL:</strong>{" "}
                  <a
                    href={formData.joinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {"Click to Join on Sunday Evenings"}
                  </a>
                </>
              )}
            </p>
            {/* Add more fields as needed */}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Left column: Personal information */}
            <div className="col-md-6 col-sm-12">
              <div className="form-group mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faUser} />
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First Name"
                    name="firstName"
                    id="firstName"
                    value={firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                {errors.firstName && (
                  <small className="text-danger">{errors.firstName}</small>
                )}
              </div>
              <div className="form-group mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faUser} />
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    name="lastName"
                    id="lastName"
                    value={lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
                {errors.lastName && (
                  <small className="text-danger">{errors.lastName}</small>
                )}
              </div>
              <div className="form-group mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faEnvelope} />
                    <span className="text-danger">*</span>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={handleChange}
                    required
                  />
                </div>
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </div>
              <div className="form-group mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faPhone} />
                    <span className="text-danger">*</span>
                  </span>
                  <PhoneInput
                    international
                    flagUrl="https://flagcdn.com/w320/{xx}.png"
                    defaultCountry={phoneCountry}
                    value={phone}
                    onChange={handlePhoneChange}
                    className="form-select"
                    placeholder="Phone Number"
                  />
                  {errors.phone && (
                    <small className="text-danger">{errors.phone}</small>
                  )}
                </div>
              </div>

              {/* Category selection */}
              <div className="form-group mb-3 d-flex align-items-center">
                {/* Category selection */}
                <div className="mr-4">
                  {/* Adult radio button with icon */}
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="adult"
                      name="category"
                      value="Adult"
                      checked={category === "Adult"}
                      onChange={handleCategoryRadioChange}
                    />
                    <label className="form-check-label" htmlFor="adult">
                      <FontAwesomeIcon icon={faUser} /> Adult
                    </label>
                  </div>

                  {/* Youth radio button with icon */}
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="youth"
                      name="category"
                      value="Youth"
                      checked={category === "Youth"}
                      onChange={handleCategoryRadioChange}
                    />
                    <label className="form-check-label" htmlFor="youth">
                      <FontAwesomeIcon icon={faChild} /> Youth
                    </label>
                  </div>
                </div>

                {/* Sabbath Group dropdown */}
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faUsers} />
                    <span className="text-danger">*</span>
                  </span>
                  <select
                    id="sabbathGroup"
                    name="sabbathGroup"
                    className="form-select"
                    value={sabbathGroup}
                    onChange={handleSabbathGroupChange}
                    required
                  >
                    <option value="">Select Group</option>
                    <option value="US">US</option>
                    <option value="UK">UK</option>
                  </select>
                  {errors.sabbathGroup && (
                    <small className="text-danger">{errors.sabbathGroup}</small>
                  )}
                </div>
                <div className="form-group mb-3 d-flex align-items-center ms-3">
                  <div className="input-group">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleShowConsentModal();
                      }}
                    >
                      Consent
                    </a>

                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="consentToUseData"
                      value={consentToUseData ? "true" : "false"}
                      checked={!!consentToUseData}
                      onChange={handleCheckChange}
                    />
                  </div>
                  {errors.zoomInvite && (
                    <small className="text-danger">{errors.zoomInvite}</small>
                  )}
                </div>
              </div>
            </div>

            {/* Right column: Address details */}
            <div className="col-md-6 col-sm-12">
              <div className="row">
                <Address
                  formData={formData}
                  setFormData={setFormData}
                  errors={errors}
                  requiredFields={["state", "country"]}
                />
              </div>
            </div>
          </div>

          {/* Form Submit / Cancel */}
          {/* Button Row */}
          {/* If there is saved data, show it */}
          <div className="d-flex flex-column mb-3">
            {userType &&
              (userType.includes("A") || userType.includes("S")) &&
              id && (
                <>
                  <div className="alert alert-info">
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="form-group d-flex align-items-center">
                          <div className="input-group">
                            <span className="input-group-text">
                              <FontAwesomeIcon
                                icon={faUser}
                                data-tooltip-id="userTypeTooltip"
                              />
                              <span className="text-danger">*</span>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="User Type - GA:Adults MGA:Music ,FRGA: Father ,MRC:Marian ,YGA: Youth"
                              name="type"
                              title="Type - GA:Adults MGA:Music ,FRGA: Father ,MRC:Marian ,YGA: Youth"
                              value={type}
                              onChange={handleChange}
                              data-tooltip-id="userTypeTooltip"
                            />
                            <Tooltip
                              id="userTypeTooltip"
                              place="top"
                              content="GA: Adults, MGA: Music, FRGA: Father, MRC: Marian, YGA: Youth"
                            />
                          </div>
                          {errors.type && (
                            <small className="text-danger">{errors.type}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group d-flex align-items-center">
                          <div className="input-group">
                            <span className="input-group-text">
                              <FontAwesomeIcon icon={faListCheck} />
                              <span className="text-danger">*</span>
                            </span>
                            <select
                              className="form-control"
                              name="status"
                              value={formData.status}
                              onChange={handleChange}
                            >
                              <option value="">Select Status</option>
                              <option value="New">New</option>
                              <option value="Approved">Approved</option>
                              <option value="Deleted">Deleted</option>
                            </select>
                          </div>
                          {errors.status && (
                            <small className="text-danger">
                              {errors.status}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group d-flex align-items-center ms-3">
                          <label
                            className="me-2"
                            data-tooltip-id="zoomInviteTooltip"
                          >
                            Zoom Invite
                          </label>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="zoomInvite"
                            checked={!!zoomInvite}
                            // Make it read-only
                            data-tip="Zoom Invite"
                            onChange={handleChange}
                            data-tooltip-id="zoomInviteTooltip"
                          />
                          <Tooltip
                            id="zoomInviteTooltip"
                            place="top"
                            content="Zoom invite to the participant"
                          />
                          {errors.zoomInvite && (
                            <small className="text-danger">
                              {errors.zoomInvite}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <div className="form-group d-flex align-items-center">
                          <div className="input-group">
                            <span className="input-group-text">
                              <FontAwesomeIcon
                                icon={faHeadset}
                                data-tooltip-id="zoomIDTooltip"
                              />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Zoom ID"
                              name="zoomID"
                              value={zoomID}
                              title="Zoom ID"
                              onChange={handleChange}
                              data-tooltip-id="zoomIDTooltip"
                            />
                            <Tooltip
                              id="zoomIDTooltip"
                              place="top"
                              content=" Zoom participant ID"
                            />
                          </div>
                          {errors.zoomID && (
                            <small className="text-danger">
                              {errors.zoomID}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group d-flex align-items-center">
                          <div className="input-group">
                            <span className="input-group-text">
                              <FontAwesomeIcon
                                icon={faHeadset}
                                data-tooltip-id="joinUrlTooltip"
                              />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="URL"
                              name="joinUrl"
                              value={joinUrl}
                              title="Join URL"
                              onChange={handleChange}
                              data-tooltip-id="joinUrlTooltip"
                            />
                            <Tooltip
                              id="joinUrlTooltip"
                              place="top"
                              content="Zoom join URL"
                            />
                          </div>
                          {errors.joinUrl && (
                            <small className="text-danger">
                              {errors.joinUrl}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="form-group d-flex align-items-center">
                          <div className="input-group">
                            <span className="input-group-text">
                              <FontAwesomeIcon icon={faListCheck} />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Remarks"
                              name="remarks"
                              value={formData.remarks || ""}
                              onChange={handleChange}
                              data-tooltip-id="remarksTooltip"
                            />
                            <Tooltip
                              id="remarksTooltip"
                              place="top"
                              content="Remarks or additional notes"
                            />
                          </div>
                          {errors.remarks && (
                            <small className="text-danger">
                              {errors.remarks}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
          </div>

          <div className="d-flex justify-content-around gap-4 mb-3">
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-light flex-grow-1"
            >
              Cancel
            </button>
            {/* Conditionally render the 'Approve' button */}
            {userType &&
              (userType.includes("A") || userType.includes("S")) &&
              record.id && (
                <button
                  className="btn btn-success flex-grow-1 mx-2"
                  onClick={handleApproveClick}
                  type="button"
                  disabled={isApproving} // Disable button when approving
                >
                  {isApproving ? (
                    <i className="fas fa-spinner fa-spin"></i> // Show spinner while loading
                  ) : (
                    "Approve"
                  )}
                </button>
              )}
            <button
              type="submit"
              className="btn btn-primary flex-grow-1"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <i className="fas fa-spinner fa-spin"></i> // Spinner for loading
              ) : (
                "Submit"
              )}
            </button>
            {/* Display approval message */}
            {approvalMessage && (
              <div className="mt-2">
                <p>{approvalMessage}</p>
              </div>
            )}
          </div>
        </form>

        {/* Alert Message */}
        {alert.message && (
          <div className={`alert alert-${alert.type} mt-4`} role="alert">
            {alert.message}
          </div>
        )}
      </div>
      {/* Modal for confirmation */}
      <AlertModal
        show={showConfirmModal}
        title="Confirm Sabbath Request"
        type="confirmation"
        message="Are you sure you want to submit the below details for Sabbath Prayer?"
        details={{
          "First Name": firstName,
          "Last Name": lastName,
          Email: email,
          Phone: phone,
        }}
        onCancel={cancelSubmit}
        onConfirm={confirmSubmit}
      />

      {/* Modal for confirmation */}
      <AlertModal
        show={showCancelModal}
        title="Cancel Sabbath Request"
        type="confirmation"
        message="Are you sure you want to navigate from the Sabbath Prayer Registration?"
        details={{}}
        onCancel={cancelCancel}
        onConfirm={confirmCancel}
      />
      {/* Success Modal */}
      <AlertModal
        show={showSuccessModal}
        title="Sabbath Registration Successful"
        message={successMessage}
        type="success"
        details={{}} // or pass additional details if necessary
        onCancel={handleCloseSuccessModal}
      />
      {/* Render the ConsentModal */}
      <ConsentModal
        show={showConsentModal}
        type={modalType}
        onCancel={handleCloseConsentModal}
      />

      <FooterPanel />
    </React.Fragment>
  );
};

export default SabbathRegistrationPage;
